export default __webpack_public_path__ + "static/meet-john-8-320052cd5267b9681b43548c0c68b87c.webp";